import styled from 'styled-components';
import {transparentize} from 'polished';
import {transition} from 'helpers/css';

export const Wrapper = styled.label`
  ${transition()};

  row-gap: 6px;
  column-gap: 12px;
  align-items: flex-start;
  grid-template-columns: auto 1fr auto;
  display: grid;

  margin: 2px 0;
  padding: 4px 10px 4px 19px;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background: ${({theme}) => `
      ${transparentize(.98, theme.colors.white)};
    `};
  }
`;

export const InputContainer = styled.div`
  grid-row: span 2;
  margin-top: 6px;
`;

export const Text = styled.strong`
  margin: 6px 0 0 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
`;

export const Note = styled.p`
  margin: 0 0 6px 0;
  grid-column: 2;
  grid-row: 2;

  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`;
